// extracted by mini-css-extract-plugin
module.exports = {"Container":"Icon__Container__34Pvm","Icon":"Icon__Icon__P8zu-"};